import { render } from "./new-user-grid.vue?vue&type=template&id=493af186"
import script from "./new-user-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./new-user-grid.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/new-user-grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "493af186"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('493af186', __exports__)) {
    api.reload('493af186', __exports__)
  }
  
  module.hot.accept("./new-user-grid.vue?vue&type=template&id=493af186", () => {
    api.rerender('493af186', render)
  })

}


export default __exports__